import React from "react";
import ReactDOM from 'react-dom';
// import { Button } from '@material-ui/core';
import { Provider } from 'react-redux';
import AppRouter from "./router/AppRouter";
import configureStore from './stores/configureStore';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import '../sass/app.scss';
import { sendGA } from "./service/Utilities";

//  if (process.env.MODE !== "production") {
//     document.head.innerHTML += '<meta name="robots" content="noindex, nofollow, noarchive" />';
//   }

window.onerror = function(message, source, lineno, colno, error) {

  if (error && error.name === 'ChunkLoadError') {
    // alert("Page content updated. Please click OK to reload page...");fffff
    // console.log('reloaded')//dfdsfdsfsdafe
    window.location.reload(true);
    return;
  }
  if(lineno == 0 && colno == 0 && !error){
    return;
  }

  if (!error && !Number(lineno) && !Number(colno)) return;

    const errorDetails = error ? error.stack : `Script: ${source} Line: ${lineno} Column: ${colno}`;
    const pagePath = window.location.pathname;
    sendGA({eventCategory:"Javascript errors reader",
      eventLabel:errorDetails,
      eventAction: `${pagePath} ${message}`,
      eventValue:1,})
};

Sentry.init({
  dsn: process.env.SENTRY_PROJECT,
  environment: process.env.MODE=="development"?"development":"production",
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
});

const store = configureStore();

const jsx = (
  <Provider store={store}>
    <AppRouter />
  </Provider>
);

ReactDOM.render(jsx, document.getElementById('root'));